import { render, staticRenderFns } from "./ApplicantDependent.vue?vue&type=template&id=2470dee2&scoped=true&"
import script from "./ApplicantDependent.vue?vue&type=script&lang=js&"
export * from "./ApplicantDependent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470dee2",
  null
  
)

export default component.exports